export default class ContentProcessor {
  constructor(element, bindable_funcs = {}) {
    this.el = element;
    this.functions = bindable_funcs;
  }

  processData(data) {
    this.parseAndReplaceContent(data);
    this.parseAndReplaceAttributes(data);
    this.parseAndSubAttributes(data);
    this.parseAndReplaceLogicOperators(data);

    // Do these last
    this.removeOnLoad();
    this.bindEvents();
  }

  bindEvents() {
    const eventsToBind = Object.keys(this.functions);
    for (let f = 0; f < eventsToBind.length; f++) {
      const funcObj = this.functions[eventsToBind[f]];
      const funcEls = this.el.querySelectorAll(funcObj.class);
      for (let i = 0; i < funcEls.length; i++) {
        // Ensure we remove the binding first so we don't get double-binds.
        funcEls[i].removeEventListener(funcObj.event, funcObj.function);
        funcEls[i].addEventListener(funcObj.event, funcObj.function);
      }
    }
  }

  removeOnLoad() {
    const els = this.el.querySelectorAll('[remove-on-load]');
    for (let i = 0; i < els.length; i++) {
      els[i].remove();
    }
  }

  logicCondition(value, is) {
    switch (is) {
    case 'blank':
      return (
        value === undefined ||
        value === null ||
        (Array.isArray(value) && value.length === 0) ||
        (typeof value === 'object' && Object.keys(value).length === 0) ||
        value.toString().trim() === ''
      );
    default:
      return false;
    }
  }

  parseAndReplaceLogicOperators(data) {
    const ifs = this.el.querySelectorAll('if, unless');
    for (let i = 0; i < ifs.length; i++) {
      const ifEl = ifs[i];
      const ifVal = ifEl.getAttribute('value').trim().split('.');
      let ifData = data;
      for (let k = 0; k < ifVal.length; k++) {
        ifData = ifData[ifVal[k]];
      }
      if (this.logicCondition(ifData, ifEl.getAttribute('is'))) {
        if (ifEl.nodeName === 'IF') {
          ifEl.outerHTML = ifEl.innerHTML;
        } else if (ifEl.nodeName === 'UNLESS') {
          ifEl.remove();
        }
      } else if (ifEl.nodeName === 'IF') {
        ifEl.remove();
      } else if (ifEl.nodeName === 'UNLESS') {
        ifEl.outerHTML = ifEl.innerHTML;
      }
    }
  }

  parseAndSubAttributes(theData) {
    const els = this.el.querySelectorAll('[sub-attribute]');

    for (let i = 0; i < els.length; i++) {
      const subAttribute = els[i].getAttribute('sub-attribute');
      const subRules = (subAttribute || '').split(',');
      for (let r = 0; r < subRules.length; r++) {
        const subRule = subRules[r].split(':');
        const attr = subRule[0];
        const fields = subRule[1].split('.');
        let value = theData;
        for (let f = 0; f < fields.length; f++) {
          if (fields[f].startsWith('\'') && fields[f].endsWith('\'')) {
            // Raw data that we're replacing, not dynamic, immediate break.
            value = fields[f].subAll(/^'|'$/g, '');
            break;
          }
          value = value[fields[f]];
          if (typeof value !== 'object' || Array.isArray(value)) {
            // we're either a value or undefined, break out
            // note that we need to allow arrays as values specially...
            break;
          }
        }

        els[i].setAttribute(attr, els[i].getAttribute(attr).replace(subRule[1], value));
      }

      els[i].removeAttribute('sub-attribute');
    }
  }

  parseAndReplaceAttributes(theData) {
    const els = this.el.querySelectorAll('[replace-attribute]');

    for (let i = 0; i < els.length; i++) {
      const replaceAttribute = els[i].getAttribute('replace-attribute');
      const replaceRules = (replaceAttribute || '').split(',');
      for (let r = 0; r < replaceRules.length; r++) {
        const replaceRule = replaceRules[r].split(':');
        const attr = replaceRule[0];
        const fields = replaceRule[1].split('.');
        let value = theData;
        for (let f = 0; f < fields.length; f++) {
          if (fields[f].startsWith('\'') && fields[f].endsWith('\'')) {
            // Raw data that we're replacing, not dynamic, immediate break.
            value = fields[f].replaceAll(/^'|'$/g, '');
            break;
          }
          value = value[fields[f]];
          if (typeof value !== 'object' || Array.isArray(value)) {
            // we're either a value or undefined, break out
            // note that we need to allow arrays as values specially...
            break;
          }
        }

        els[i].setAttribute(attr, value);
      }

      els[i].removeAttribute('replace-attribute');
    }
  }

  getElementByKey(container, key) {
    let el = container.querySelector(key.toLowerCase());
    // This needs to exist for element names that would normally
    //   be actual elements and we have to just rename them.
    el ||= container.querySelector(`item-${key.toLowerCase()}`);
    return el;
  }

  parseAndReplaceContent(theData) {
    const els = this.el.querySelectorAll('[replace-with]');

    for (let i = 0; i < els.length; i++) {
      const el = els[i]
      if (typeof el.getAttribute('replace-with') !== 'string') {
        continue;
      }

      const replaceWithOpts = el.getAttribute('replace-with').split(',');
      for (let r = 0; r < replaceWithOpts.length; r++) {
        const replaceScope = replaceWithOpts[r].trim().split('.');
        let data = theData;
        for (let s = 0; s < replaceScope.length; s++) {
          data = data[replaceScope[s].trim()];

          if (Array.isArray(data)) {
            if (replaceScope[s + 1] === 'first') {
              // Fast foward to the first item in the array          
              data = data[0];
              if (data === undefined) {
                break;
              }
              s++;
            } else {
              // In this case we don't have a way to progress into the array
              // Just break, it's assumed that we contain a template
              // and that we'll be looping over the array.
              break;
            }
          } else if (typeof data !== 'object') {
            // we're either a value or undefined, break out
            break;
          }
        }

        if (!data || data === 'N/A') {
          // In this case we've come across a bad value
          // Try to skip over to the next option or just straight on to the next
          // replacement value.
          continue;
        }

        if (el.nodeName === 'TEMPLATE') {
          if (Array.isArray(data)) {
            for (let k = 0; k < data.length; k++) {
              let conditionalFail = false;
              // If we have an unless attrib we need to skip if it is NOT true!
              const unlessAttrib = el.getAttribute('unless');
              if (unlessAttrib) {
                const unlessKeys = unlessAttrib.split('.');
                let unlessData = data[k];
                for (let uk = 0; uk < unlessKeys.length; uk++) {
                  if (!unlessData) {
                    conditionalFail = true;
                    break;
                  }
                  unlessData = unlessData[unlessKeys[uk]]
                }
                if (!conditionalFail) {
                  conditionalFail = this.logicCondition(unlessData, el.getAttribute('is'))
                }
              }

              if (!conditionalFail) {
                const template = el.content.cloneNode(true);
                if (typeof data[k] !== 'object') {
                  const node = template.querySelector('value');
                  if (node == null) {
                    console.error(
                      'No "value" node for single data-point template! Data:',
                      data[k],
                      "\nTemplate:",
                      template
                    );
                  } else {
                    node.replaceWith(data[k]); 
                  }
                  el.parentElement.insertBefore(template, el);
                } else {
                  const subProcessor = new ContentProcessor(template, this.functions);
                  subProcessor.processData(data[k]);
                  const templateKeys = Object.keys(data[k]);
                  for (let t = 0; t < templateKeys.length; t++) {
                    const node = this.getElementByKey(template, templateKeys[t]);
                    if (node !== null) {
                      node.innerHTML = data[k][templateKeys[t]];
                    }
                  }
                  el.parentElement.appendChild(template);
                }
              }
            }
          } else if (typeof data === 'object') {
            let conditionalFail = false;
            // If we have an unless attrib we need to skip if it is NOT true!
            const unlessAttrib = el.getAttribute('unless');
            if (unlessAttrib) {
              const unlessKeys = unlessAttrib.split('.');
              let unlessData = data;
              for (let uk = 0; uk < unlessKeys.length; uk++) {
                if (!unlessData) {
                  conditionalFail = true;
                  break;
                }
                unlessData = unlessData[unlessKeys[uk]]
              }
              if (!conditionalFail) {
                conditionalFail = this.logicCondition(unlessData, el.getAttribute('is'))
              }
            }

            // Break to the next loop iteration if any conditionals were false.
            if (conditionalFail) break;

            const templateKeys = Object.keys(data);
            const keysReplaced = {};

            let template;
            const replacePerKey = el.hasAttribute('replace-per-key');
            if (!replacePerKey) {
              template = el.content.cloneNode(true);
            }

            for (let t = 0; t < templateKeys.length; t++) {
              const templateKey = templateKeys[t];

              if (replacePerKey) {
                if (!Array.isArray(data[templateKey])) {
                  console.error(`'replace-per-key' invoked but data for ${templateKey} was not an array!`);
                  break;
                }

                for (let k = 0; k < data[templateKey].length; k++) {
                  template = el.content.cloneNode(true);

                  // Handle <key></key> replacement.
                  // Note that this should only ever be replaced once per key!
                  const keyNode = template.querySelector('key');
                  if (keyNode !== null) {
                    if (keysReplaced[templateKey]) {
                      keyNode.remove();
                    } else {
                      keyNode.replaceWith(templateKey);
                      keysReplaced[templateKey] = true;
                    }
                  }

                  const innerData = data[templateKey][k];
                  const innerKeys = Object.keys(innerData);
                  for (let it = 0; it < innerKeys.length; it++) {
                    const node = this.getElementByKey(template, innerKeys[it]);
                    if (node !== null) {
                      node.innerHTML = innerData[innerKeys[it]];
                    }
                  }
                  el.parentElement.appendChild(template);
                }
              } else {
                let node = this.getElementByKey(template, templateKey);
                if (node !== null) {
                  node.replaceWith(data[templateKey]);
                }
              }
            }

            if (!replacePerKey) {
              const subProcessor = new ContentProcessor(template, this.functions);
              subProcessor.processData(data);

              el.parentElement.appendChild(template);
            }
          } else {
            const template = el.content.cloneNode(true);
            const node = template.querySelector('value');
            if (node == null) {
              console.error(
                'No "value" node for single data-point template! Data:',
                data,
                "\nTemplate:",
                template
              );
            } else {
              node.replaceWith(data); 
            }
            el.parentElement.insertBefore(template, el);
          }
        } else if (el.dataset.replaceEl) {
          const newEl = document.createElement(el.dataset.replaceEl);
          newEl.classList.add(el.classList);
          newEl.innerHTML = data;
          el.replaceWith(newEl);
        } else {
          el.innerHTML = data;
        }

        el.removeAttribute('replace-with');

        break; // if we got here we rendered, don't allow other options!
      }
    }

    // Finally, do some cleanup and remove any templates we had left over.
    // If we don't remove these then they can cause display issues.
    // TODO: determine if there's a way to do this without removing these.
    //   it'd be nice to be able to trigger updates on the content.
    //   Will also need to not remove stuff on everything else, obviously,
    //   but then we have to not look at sub elements AFTER they've already
    //   been processed.
    const elsToRemove = this.el.querySelectorAll('template');
    for (let i = 0; i < elsToRemove.length; i++) {
      elsToRemove[i].remove();
    }
  }

}
